// Nouveautés affichées dans la carte « Mise à jour disponible » (3 lignes max). À remplir à chaque livraison depuis le rapport.
export const RELEASE_NOTES = [
  "Dashboard du lot : 6 sections, fiches Échéancier et Étapes refaites",
  "Genre Mr / Mme / Mlle, profession avec mémoire, Wilaya → Daïra → Commune (69 wilayas)",
  "Mise à jour : carte discrète, plus aucun rechargement forcé",
];
